/**
 * @fileoverview GET handler for the "/companies/:company_id/mobile_app_linking_configs/:id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdMobileAppLinkingConfigsId } from "./constants";
import type {
  GetCompaniesCompanyIdMobileAppLinkingConfigsIdProps,
  GetCompaniesCompanyIdMobileAppLinkingConfigsIdResult,
} from "./types";
import { isGetCompaniesCompanyIdMobileAppLinkingConfigsIdResult } from "./validators";

export const getCompaniesCompanyIdMobileAppLinkingConfigsId = reactQueryFetcherAdapter(
  companiesCompanyIdMobileAppLinkingConfigsId,
  (
    signal: AbortSignal,
    { companyId, id }: GetCompaniesCompanyIdMobileAppLinkingConfigsIdProps
  ): Promise<GetCompaniesCompanyIdMobileAppLinkingConfigsIdResult> => {
    return fetch(`/companies/${companyId}/mobile_app_linking_configs/${id}`, "GET", {}, { signal });
  },
  isGetCompaniesCompanyIdMobileAppLinkingConfigsIdResult
);
